import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["draggable"]
const _hoisted_2 = { class: "celda-numeracion" }
const _hoisted_3 = {
  key: 0,
  class: "numeracion-simple"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "acciones" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "acciones" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "acciones" }
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

import { ref, computed, inject, reactive, watch } from 'vue'
import { useRouter } from 'vue-router'
import type Componente from '@/interfaces/Componente'
import type Indicador from '@/interfaces/Indicador'
import type Instrumento from '@/interfaces/Instrumetos'
import { estiloJerarquico } from '@/utils/estilosJerarquia'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'

interface DragState {
  dragging: Componente | null
  dropTargetId: number | null
  dropSide: 'before' | 'after'
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FilaComponente',
  props: {
    comp: {},
    nivel: {},
    ultimoNivel: {},
    componenteSeleccionado: {},
    expandido: {},
    toggleExpandido: {},
    esIndicadores: { type: Boolean },
    esIndicadorFn: {},
    puedeAcceder: { type: Boolean },
    instrumentosPorIndicadorFn: {},
    mostrarBotonCalificar: { type: Boolean },
    mostrarAccionesComponente: { type: Boolean, default: true },
    mostrarAccionesIndicador: { type: Boolean, default: true },
    ocultarFilaComponente: { type: Boolean, default: false },
    componenteEditandoId: {},
    niveles: {},
    obtenerNumeracion: {},
    posicion: { default: 0 },
    totalHermanos: { default: 0 },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:componenteSeleccionado", "modificar", "eliminar", "agregarHijo", "agregarInstrumento", "vincularFormulario", "acceder", "modificarIndicador", "eliminarIndicador", "modificarInstrumento", "eliminarInstrumento", "calificarInstrumento", "calificarIndicador", "reordenar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Fila de un componente dentro de las vistas de lista.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const tipoComponenteStore = useGestionTipoComponente()

/**
 * El tipo del indicador sale de `tipo_componentes` (Documental, Cuantitativa,
 * Opinión). Se resuelve por NOMBRE y no por id fijo: los ids dependen del
 * seeder y podrían no ser los mismos en otra base.
 */
function esIndicadorDeOpinion(indicador?: Indicador): boolean {
  if (!indicador?.id_tipo_componente) return false
  const tipo = (tipoComponenteStore.tipos ?? []).find(
    (t: any) => t.id_tipo_componente === indicador.id_tipo_componente
  )
  return /opini/i.test(String(tipo?.nombre ?? ''))
}

const router = useRouter()
const props = __props

const emit = __emit

const seleccionCalificar = inject<import('vue').Ref<string | null>>('seleccionCalificar', ref(null))

const dragState = inject<DragState>('dragState', reactive({ dragging: null, dropTargetId: null, dropSide: 'after' as const }))

const isDragging = computed(() => dragState.dragging?.id_componente === props.comp.id_componente)
const isDropTarget = computed(() => dragState.dropTargetId === props.comp.id_componente)
const isValidDropTarget = computed(() =>
  dragState.dragging != null &&
  dragState.dragging.id_componente !== props.comp.id_componente &&
  dragState.dragging.padre_id === props.comp.padre_id
)

function onDragStart(e: DragEvent) {
  dragState.dragging = props.comp
  if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move'
}

function onDragOver(e: DragEvent) {
  if (!isValidDropTarget.value) return
  dragState.dropTargetId = props.comp.id_componente!
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
  dragState.dropSide = e.clientY < rect.top + rect.height / 2 ? 'before' : 'after'
}

function onDragEnd() {
  dragState.dragging = null
  dragState.dropTargetId = null
}

function onDrop() {
  if (!dragState.dragging || !isValidDropTarget.value) {
    dragState.dragging = null
    dragState.dropTargetId = null
    return
  }
  const dragged = dragState.dragging
  const side = dragState.dropSide
  dragState.dragging = null
  dragState.dropTargetId = null
  emit('reordenar', { dragged, target: props.comp, side })
}

function seleccionarCalificar(id: string) {
  // Limpiar selección de componentes
  emit('update:componenteSeleccionado', null)
  // Toggle selección actual
  seleccionCalificar.value = seleccionCalificar.value === id ? null : id
}

function getInstrumentos(indicadorId: number): Instrumento[] {
  return props.instrumentosPorIndicadorFn
    ? props.instrumentosPorIndicadorFn(indicadorId)
    : []
}

function seleccionar(comp: Componente) {
  // Limpiar selección de calificar/indicadores/instrumentos
  seleccionCalificar.value = null
  // Toggle selección de componente
  if (props.componenteSeleccionado?.id_componente === comp.id_componente) {
    emit('update:componenteSeleccionado', null)
  } else {
    emit('update:componenteSeleccionado', comp)
  }
}

const esSeleccionado = computed(
  () => props.componenteSeleccionado?.id_componente === props.comp.id_componente
)

const nombreLocal = ref(props.comp.nombre)

watch(
  () => esSeleccionado.value,
  (nuevo) => {
    if (nuevo) {
      nombreLocal.value = props.comp.nombre
    }
  }
)

function esIndicador(c: Componente): boolean {
  if (props.esIndicadorFn) return props.esIndicadorFn(c)
  return false
}

function obtenerNombreNivel(nivel: number): string {
  if (!props.niveles || nivel >= props.niveles.length) {
    return `Nivel ${nivel + 1}`
  }
  return props.niveles[nivel]
}

function obtenerNumeracionDisplay(): string {
  if (!props.obtenerNumeracion) return ''
  return props.obtenerNumeracion(props.comp, props.nivel)
}

// Computed para determinar si se puede agregar un hijo
const puedoAgregarHijo = computed(() => {
  return props.nivel < props.ultimoNivel - 1
})

const hijosOrdenados = computed(() =>
  [...(props.comp.children ?? [])].sort((a, b) =>
    (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
  )
)

function onModificarClick() {
  if (!props.esIndicadores) {
    emit('modificar', props.comp)
  }
}

function verInstrumento(inst: Instrumento) {
  router.push({
    name: 'InstrumentoDetalle',
    params: { id: inst.id_instrumento },
    query: { id_componente: props.comp.id_componente }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FilaComponente = _resolveComponent("FilaComponente", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.ocultarFilaComponente)
      ? (_openBlock(), _createElementBlock("tr", {
          key: 0,
          style: _normalizeStyle(_unref(estiloJerarquico)(_ctx.nivel, (_ctx.comp.children?.length ?? 0) > 0)),
          class: _normalizeClass({
      'fila-editando': _ctx.comp.id_componente === _ctx.componenteEditandoId,
      'fila-seleccionada': _ctx.componenteSeleccionado?.id_componente === _ctx.comp.id_componente,
      'dragging': isDragging.value,
      'drop-before': isDropTarget.value && _unref(dragState).dropSide === 'before',
      'drop-after': isDropTarget.value && _unref(dragState).dropSide === 'after',
    }),
          draggable: !_ctx.esIndicadores && !!_ctx.mostrarAccionesComponente && _ctx.totalHermanos > 1,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (seleccionar(_ctx.comp))),
          onDragstart: _withModifiers(onDragStart, ["stop"]),
          onDragover: _withModifiers(onDragOver, ["stop","prevent"]),
          onDragend: onDragEnd,
          onDrop: _withModifiers(onDrop, ["stop","prevent"])
        }, [
          _createElementVNode("td", _hoisted_2, [
            (obtenerNumeracionDisplay())
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(obtenerNumeracionDisplay()), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
          ]),
          _createElementVNode("td", {
            style: _normalizeStyle({ paddingLeft: `${_ctx.nivel * 48}px` }),
            class: "indentado"
          }, [
            (!_ctx.esIndicadores && _ctx.mostrarAccionesComponente && _ctx.totalHermanos > 1)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "drag-handle",
                  title: "Arrastra para reordenar",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, "⠿"))
              : _createCommentVNode("", true),
            ((_ctx.comp.children?.length ?? 0) > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleExpandido(_ctx.comp.id_componente!))),
                  class: _normalizeClass(["flecha", { expandido: _ctx.expandido.has(_ctx.comp.id_componente!) }])
                }, _toDisplayString(_ctx.expandido.has(_ctx.comp.id_componente!) ? '▼ Ocultar' : '▶ Mostrar'), 3))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.comp.nombre), 1)
          ], 4),
          _createElementVNode("td", _hoisted_5, [
            (!_ctx.esIndicadores && _ctx.mostrarAccionesComponente)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    disabled: _ctx.loading,
                    onClick: onModificarClick
                  }, "Modificar", 8, _hoisted_6),
                  _createElementVNode("button", {
                    disabled: _ctx.loading,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('eliminar', _ctx.comp)))
                  }, "Eliminar", 8, _hoisted_7),
                  (puedoAgregarHijo.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.loading,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('agregarHijo', { padre: _ctx.comp, nivel: _ctx.nivel })))
                      }, "➕ Agregar " + _toDisplayString(_ctx.niveles?.[_ctx.nivel + 1] ?? 'Componente'), 9, _hoisted_8))
                    : _createCommentVNode("", true)
                ], 64))
              : (_ctx.esIndicadores && _ctx.mostrarAccionesComponente)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      disabled: _ctx.loading,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('agregarHijo', { padre: _ctx.comp, nivel: _ctx.nivel })))
                    }, "➕ Agregar Indicador", 8, _hoisted_9),
                    (esIndicador(_ctx.comp))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.puedeAcceder)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('acceder', _ctx.comp)))
                              }, "Acceder"))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
          ])
        ], 46, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.expandido.has(_ctx.comp.id_componente!))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(hijosOrdenados.value, (hijo, index) => {
          return (_openBlock(), _createBlock(_component_FilaComponente, {
            key: hijo.id_componente,
            comp: hijo,
            nivel: _ctx.nivel + 1,
            ultimoNivel: _ctx.ultimoNivel,
            componenteSeleccionado: _ctx.componenteSeleccionado,
            "onUpdate:componenteSeleccionado": _cache[7] || (_cache[7] = ($event: any) => (emit('update:componenteSeleccionado', $event))),
            expandido: _ctx.expandido,
            toggleExpandido: _ctx.toggleExpandido,
            esIndicadores: _ctx.esIndicadores,
            esIndicadorFn: _ctx.esIndicadorFn,
            puedeAcceder: _ctx.puedeAcceder,
            instrumentosPorIndicadorFn: _ctx.instrumentosPorIndicadorFn,
            mostrarBotonCalificar: _ctx.mostrarBotonCalificar,
            mostrarAccionesComponente: _ctx.mostrarAccionesComponente,
            mostrarAccionesIndicador: _ctx.mostrarAccionesIndicador,
            ocultarFilaComponente: _ctx.ocultarFilaComponente,
            componenteEditandoId: _ctx.componenteEditandoId,
            niveles: _ctx.niveles,
            obtenerNumeracion: _ctx.obtenerNumeracion,
            posicion: index + 1,
            totalHermanos: hijosOrdenados.value.length,
            loading: _ctx.loading,
            onModificar: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('modificar', $event))),
            onEliminar: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('eliminar', $event))),
            onAgregarHijo: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('agregarHijo', $event))),
            onAgregarInstrumento: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('agregarInstrumento', $event))),
            onVincularFormulario: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('vincularFormulario', $event))),
            onAcceder: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('acceder', $event))),
            onModificarIndicador: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('modificarIndicador', $event))),
            onEliminarIndicador: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('eliminarIndicador', $event))),
            onModificarInstrumento: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('modificarInstrumento', $event))),
            onEliminarInstrumento: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('eliminarInstrumento', $event))),
            onCalificarInstrumento: _cache[18] || (_cache[18] = ($event: any) => (emit('calificarInstrumento', $event))),
            onCalificarIndicador: _cache[19] || (_cache[19] = ($event: any) => (emit('calificarIndicador', $event))),
            onReordenar: _cache[20] || (_cache[20] = ($event: any) => (emit('reordenar', $event)))
          }, null, 8, ["comp", "nivel", "ultimoNivel", "componenteSeleccionado", "expandido", "toggleExpandido", "esIndicadores", "esIndicadorFn", "puedeAcceder", "instrumentosPorIndicadorFn", "mostrarBotonCalificar", "mostrarAccionesComponente", "mostrarAccionesIndicador", "ocultarFilaComponente", "componenteEditandoId", "niveles", "obtenerNumeracion", "posicion", "totalHermanos", "loading"]))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.esIndicadores)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.comp.indicadores ?? [], (indicador) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `indicador-${indicador.id_indicador}`
          }, [
            _createElementVNode("tr", {
              class: _normalizeClass(["fila-indicador", { 'fila-calificar-seleccionada': _unref(seleccionCalificar) === `indicador-${indicador.id_indicador}` }]),
              onClick: _withModifiers(($event: any) => (seleccionarCalificar(`indicador-${indicador.id_indicador}`)), ["stop"])
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("td", null, "Indicador", -1)),
              _createElementVNode("td", {
                style: _normalizeStyle({ paddingLeft: `${_ctx.ocultarFilaComponente ? 0 : (_ctx.nivel + 1) * 48}px` }),
                class: "indentado"
              }, _toDisplayString(indicador.enunciado ?? indicador.nombre), 5),
              _createElementVNode("td", _hoisted_11, [
                (_ctx.mostrarAccionesIndicador)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        disabled: _ctx.loading,
                        onClick: ($event: any) => (_ctx.$emit('modificarIndicador', indicador))
                      }, "Modificar", 8, _hoisted_12),
                      _createElementVNode("button", {
                        disabled: _ctx.loading,
                        onClick: ($event: any) => (_ctx.$emit('eliminarIndicador', indicador))
                      }, "Eliminar", 8, _hoisted_13),
                      (!esIndicadorDeOpinion(indicador))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.loading,
                            onClick: ($event: any) => (_ctx.$emit('agregarInstrumento', indicador))
                          }, "➕ Agregar Instrumento", 8, _hoisted_14))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: _ctx.loading,
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('vincularFormulario', indicador)), ["stop"])
                          }, "🔗 Vincular Formulario", 8, _hoisted_15))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.mostrarBotonCalificar)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn calificar",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('calificarIndicador', { indicador })), ["stop"])
                    }, " Calificar ", 8, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_10),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getInstrumentos(indicador.id_indicador), (instrumento) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `instrumento-${instrumento.id_instrumento}-ind-${indicador.id_indicador}`,
                class: _normalizeClass(["fila-instrumento", { 'fila-calificar-seleccionada': _unref(seleccionCalificar) === `instrumento-${instrumento.id_instrumento}` }]),
                onClick: _withModifiers(($event: any) => (seleccionarCalificar(`instrumento-${instrumento.id_instrumento}`)), ["stop"])
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "Instrumento", -1)),
                _createElementVNode("td", {
                  style: _normalizeStyle({ paddingLeft: `${_ctx.ocultarFilaComponente ? 24 : (_ctx.nivel + 2) * 48}px` }),
                  class: "indentado"
                }, _toDisplayString(instrumento.herramienta), 5),
                _createElementVNode("td", _hoisted_18, [
                  (_ctx.mostrarAccionesIndicador)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (esIndicadorDeOpinion(indicador))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              disabled: _ctx.loading,
                              onClick: ($event: any) => (_ctx.$emit('modificarInstrumento', instrumento))
                            }, "Modificar", 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          disabled: _ctx.loading,
                          onClick: ($event: any) => (_ctx.$emit('eliminarInstrumento', { instrumento, indicador }))
                        }, "Eliminar", 8, _hoisted_20),
                        _createElementVNode("button", {
                          class: "btn guardar",
                          onClick: ($event: any) => (verInstrumento(instrumento))
                        }, "Ver", 8, _hoisted_21)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.mostrarBotonCalificar)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn calificar",
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('calificarInstrumento', { instrumento, indicador })), ["stop"])
                      }, " Calificar ", 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_17))
            }), 128))
          ], 64))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}
}

})